import { theme } from '@approvalmax/theme';
import { SignupConfirmationLinkIcon } from 'modules/sprites';
import { font } from 'modules/styles';
import { FC, memo } from 'react';
import styled from 'styled-components';

import { messages } from './VerifyEmailModule.messages';

const VerifyEmail = styled.div`
    display: flex;
    flex-flow: column;
    width: 540px;
    max-width: 100%;
    padding: 50px 50px 70px 50px;
    background: #fff;
    margin-bottom: 50px;

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        width: auto;
    }
`;

const Title = styled.div`
    text-align: center;
    text-transform: uppercase;
    ${font(18, '#000', 'semibold')}
`;

const SuccessIcon = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 44px;
`;

const VerifyEmailModule: FC = () => (
    <VerifyEmail>
        <Title>{messages.titleSuccessText}</Title>

        <SuccessIcon>
            <SignupConfirmationLinkIcon width={110} height={82} />
        </SuccessIcon>
    </VerifyEmail>
);

export default memo(VerifyEmailModule);
